// The Creator Studio spoke. Hard-coded in a couple of places already (creator-program, the app header);
// this is the one name to import so a fourth copy does not appear.
export const CREATOR_STUDIO_URL = 'https://creator-studio.civitai.com';
